import './style/style.sass';

import React from 'react';

import { ImageAndDescr } from '../share/ImageAndDescr';
import { QuestionMark } from '../share/QuestionMark';

const ACTIVE = 'clicked'

export class AttributeDesktop extends React.Component {
  constructor(props) {
    super(props)

    this.onClick = this.onClick.bind(this)
  }

  onClick() {
    this.props.toggleDescription({ attributHint: this.hint })

    if (this.props.attr.isActive) {
      this.parent.classList.remove(ACTIVE)
    } else {
      this.parent.classList.add(ACTIVE)
    }
  }

  render() {
    const { name, short_name, isDisabled } = this.props.attr;

    const style = {
      marginBottom: (this.props.attr && this.parent && this.props.attr.isActive)
        ? this.parent.style.marginBottom
        : ''
    };

    return (
      <div
        ref={parent => this.parent = parent}
        className={"attribute " + (this.props.attr.isActive ? ACTIVE : '')}
        style={style}
        onClick={this.onClick}
      >
        <QuestionMark name={name} isDisabled={isDisabled} />
        <div className="attribute-hint">
          <ImageAndDescr attr={this.props.attr} />
        </div>

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/snippets/ExplanationAttributes/impl/AttributeDesktop/AttributeDesktop.jsx